import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.BUSCAR_ESTOQUE_ORGAOS]({ state }, idAtaItem) {
		const { data } = await api.transferencia.buscarEstoquePorOrgaos(idAtaItem, state.paginacao)
		return data
	},

	async [actionTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.BUSCAR_ORGAOS]({ state }) {
		const { filtro } = state

		const { data } = await api.transferencia.buscarOrgaosCessionarios(filtro)
		return data
	},

	async [actionTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.TRANSFERIR_SALDO]({ state }) {
		state.transferirSaldo.idUoCessionario = state.filtro.orgaoCessionario.id

		await api.transferencia.transferirSaldo({
			...state.transferirSaldo,
			tipoAlteracaoSaldo: state.orgaoCedente.tipoAlteracaoSaldo,
		})
	},
}
